import { Box } from "@mui/material";
import styles from "../../../styles/pages/analyticseditor.module.scss";
import React, { memo } from "react";
import styles2 from "../../../styles/pages/home.module.scss";
import stylesAnalytics from "../../../styles/pages/analytics.module.scss";
import "react-perfect-scrollbar/dist/css/styles.css";
import assest from "../../../json/assest";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Link } from "react-router-dom";
import { emptyHandleTwo } from "../../../lib/functions/utils.lib";

const ConfirmedVideos = ({
  data,
  handleOpenApprovedModal,
  handleOpenRejectedModal,
  handleOpenWebsiteModal,
}) => {
  console.warn("ConfirmedVideos", data);
  return (
    <>
      <Box
        className={`${styles.analyticBoxOne} ${styles.commonSmallBoxWrapperAnalytic}`}
      >
        <Box className="commonSmallBox commonSmallBoxAnalytics analyticBoxOne">
          <Box className={styles2.commonSmallBox}>
            <Box
              className={`${styles2.infoTable} ${stylesAnalytics.confirmAnalytics}`}
            >
              <Box className={styles2.infoTable_head}>
                <Link href="">
                  <Box className={styles2.tble_hdng}>Confirmed Videos</Box>
                  <Box className={styles2.tble_hdng}>
                    {emptyHandleTwo(data?.confirmed_videos?.total)}
                  </Box>
                </Link>
              </Box>

              <Box className={styles2.infoTble_body}>
                <Box
                  className={styles2.infoTble_row}
                  onClick={handleOpenApprovedModal}
                >
                  <Link href="">
                    <Box
                      className={`${styles2.infoTble_cell} ${stylesAnalytics.infoTblecellAnalytics}`}
                    >
                      <Box className={styles2.tble_innrWrp}>
                        <span>Approved</span>
                        <img
                          src={assest.arrowIcon}
                          width={53}
                          height={3}
                          alt=""
                        />
                        <span>Approved</span>
                      </Box>
                    </Box>
                    <Box
                      className={`${styles2.infoTble_cell} ${stylesAnalytics.infoTblecellAnalytics}`}
                    >
                      {emptyHandleTwo(data?.confirmed_videos.approved_approved)}
                    </Box>
                  </Link>
                </Box>
                <Box
                  className={styles2.infoTble_row}
                  onClick={handleOpenRejectedModal}
                >
                  <Link href="">
                    <Box
                      className={`${styles2.infoTble_cell} ${stylesAnalytics.infoTblecellAnalytics}`}
                    >
                      <Box className={styles2.tble_innrWrp}>
                        <span>Rejected</span>
                        <img
                          src={assest.arrowIcon}
                          width={53}
                          height={3}
                          alt=""
                        />
                        <span>Rejected</span>
                      </Box>
                    </Box>
                    <Box
                      className={`${styles2.infoTble_cell} ${stylesAnalytics.infoTblecellAnalytics}`}
                    >
                      {emptyHandleTwo(
                        data?.confirmed_videos?.rejected_rejected
                      )}
                    </Box>
                  </Link>
                </Box>
                <Box
                  className={styles2.infoTble_row}
                  onClick={handleOpenWebsiteModal}
                >
                  <Link href="">
                    <Box
                      className={`${styles2.infoTble_cell} ${stylesAnalytics.infoTblecellAnalytics}`}
                    >
                      <Box className={styles2.tble_innrWrp}>
                        <span>Website Only</span>
                        <img
                          src={assest.arrowIcon}
                          width={53}
                          height={3}
                          alt=""
                        />
                        <span>Website Only</span>
                      </Box>
                    </Box>
                    <Box
                      className={`${styles2.infoTble_cell} ${stylesAnalytics.infoTblecellAnalytics}`}
                    >
                      {emptyHandleTwo(data?.confirmed_videos?.website_website)}
                    </Box>
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default memo(ConfirmedVideos);
